const MainContainer = ({ children }) => {
    return (
        <div className="px-4 py-4 2xl:px-[200px]">
            {children}
        </div>
    )
}

export default MainContainer;